import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { PageTitle } from "@/components/Layout";
import { ProfileForm } from "@/pages/Onboarding";

export default function EditProfile() {
  const { t } = useApp();
  const nav = useNavigate();
  return (
    <div>
      <PageTitle>{t("Edit profile")}</PageTitle>
      <ProfileForm submitLabel={t("Save changes")} onSaved={() => { toast.success(t("Profile saved")); nav("/profile"); }} />
    </div>
  );
}
